import { SUBTYPES } from "entities/CostType";
import { useRequestStore } from "entities/Request";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Form } from "shared/ui";

export const JobRelatedExpense = React.memo(
  // @ts-ignore
  ({ disabled, costTypeOptions, costLineData }) => {
    const { t } = useTranslation("CostLine");
    const {
      register,
      formState: { errors },
      getValues,
      resetField,
      setValue,
    } = useFormContext();
    const isJobRelated = useWatch({ name: "is_job_related" });
    const request = useRequestStore((state) => state.request);

    // Persisting cost and currency to set them back if job related switch would be unchecked
    const [prevCost, setPrevCost] = React.useState(null);
    const [prevCurrency, setPrevCurrency] = React.useState(null);

    React.useEffect(() => {
      if (costTypeOptions.length === 0) return;
      if (isJobRelated) {
        const currentCost = getValues("cost_type");
        const currentCurrency = getValues("currency_code");

        if (currentCost && currentCost.value.subtype === SUBTYPES.JOB_RELATED)
          return;

        setPrevCost(currentCost);
        setPrevCurrency(currentCurrency);
        resetField("cost_type", {
          defaultValue:
            costTypeOptions.length === 1 ? costTypeOptions[0] : null,
        });
        resetField("currency_code", {
          defaultValue: request?.local_currency
            ? { value: request.local_currency, label: request.local_currency }
            : null,
        });
      } else {
        setValue("cost_type", prevCost);
        setValue("currency_code", prevCurrency);
        setValue("vat", null);
      }
    }, [isJobRelated, costTypeOptions, request?.local_currency]);

    // Prevent conditional rendering of the sap_vendor_number field from making the cost line dirty
    React.useEffect(() => {
      resetField("sap_vendor_number", {
        defaultValue: costLineData?.sap_vendor_number ?? "",
        keepDirty: true,
      });
      resetField("invoice_number", {
        defaultValue: costLineData?.invoice_number ?? "",
        keepDirty: true,
      });
    }, [isJobRelated]);

    return (
      <>
        <Form.Check
          name="is_job_related"
          id="is_job_related"
          register={register}
          type="switch"
          label={t("labels.is_job_related")}
          className="mb-3"
          disabled={disabled}
        />
        {isJobRelated && (
          <Row className="mb-4">
            <Form.NumericInput
              name="sap_vendor_number"
              label={t("labels.sap_vendor_number")}
              allowNegative={false}
              allowLeadingZeros={false}
              valueIsNumericString={true}
              isAllowed={({ value }) => !value.startsWith("0")}
              decimalScale={0}
              disabled={disabled}
              displayAs={Col}
              error={errors.sap_vendor_number}
            />
            <Form.Input
              register={register}
              name="invoice_number"
              label={t("labels.invoice_number")}
              error={errors.invoice_number}
              displayAs={Col}
              disabled={disabled}
            />
          </Row>
        )}
      </>
    );
  }
);
